import { Link } from "react-router-dom";
import type { Movie } from "@/types";

interface MovieCardProps {
  movie: Movie;
}

export default function MovieCard({ movie }: MovieCardProps) {
  return (
    <Link
      to={`/detail/${movie.id}`}
      className="group flex flex-col cursor-pointer"
      data-product-shop
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden rounded-lg bg-background-200">
        <img
          src={movie.poster}
          alt={`${movie.title} 电影海报`}
          title={`${movie.title} - 适合夫妻二人看的影片`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-2.5 top-2.5 flex items-center gap-1 rounded-full bg-background-50/90 px-2 py-0.5 text-xs font-medium text-primary-800 backdrop-blur-sm">
          <i className="ri-star-fill text-[11px] text-primary-500"></i>
          {movie.rating.toFixed(1)}
        </span>
      </div>

      <div className="mt-3 flex flex-1 flex-col">
        <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-950 transition-colors group-hover:text-primary-700">
          {movie.title}
        </h3>
        <p className="mt-1 text-xs md:text-sm text-foreground-600">
          {movie.genres.join(" · ")} · {movie.year}
        </p>
        <p className="mt-1.5 line-clamp-2 text-xs md:text-sm leading-relaxed text-foreground-700">
          {movie.review}
        </p>
      </div>
    </Link>
  );
}